module.exports = __webpack_public_path__ + "img/icon_kieferchirugie.7527195b.svg";